import React, { useState, useEffect } from "react";
import "./EditProfileResult.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Api from "../../Common/api.jsx";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { notifications } from "../../Helpers/Notifications";
import { ToastContainer } from "react-toastify";
import { Scrollbars } from "react-custom-scrollbars";

export default class EditProfileResult extends React.Component {
  constructor(props) {
    super(props);
    this.dName = "";

    this.state = {
      isSaving: false,
      error: "",
      message: "",

      profile_picture: null,
      banner_picture: null,
      twitter_profile: "",
      mobile: "",
      Oldmobile: "",

      bio: "",
      oldEmail: "",
      email: "",
      custom_url: "",
      personal_website: "",
      user_id: null,
      user_name: "",

      otp: "",
      popupFor: null,

      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",

      is_email_verified: false,
      is_mobile_verified: false,
      is_user_verified: false,

      isSaving: false,
      openPopup: false,
      inputtype: "file",
    };
  }

  async componentDidMount() {
    window.addEventListener("click", () => {
      if (document.getElementsByClassName("search-autocomplete")) {
        document.getElementsByClassName(
          "search-autocomplete"
        )[0].style.display = "none";
      }
    });
    let account = await new MetaMaskService().getAccount();
    this.getUserProfile(account);
  }

  togglePopup(value) {
    this.setState({ openPopup: value });
  }

  getUserProfile(account) {
    const api = new Api();
    var parameter = "";
    api
      .get("get_user/?account=" + account)
      .then((response) => {
        this.setState({
          user_name: response.data.user_name,
          user_id: response.data.user_id,
          bio: response.data.bio,
          custom_url: response.data.custom_url,
          twitter_profile: response.data.twitter_profile,
          personal_website: response.data.personal_website,
          profile_picture: response.data.profile_picture,
          banner_picture: response.data.banner_picture,
          email: response.data.email,
          oldEmail: response.data.email,
          Oldmobile: response.data.mobile,
          mobile: response.data.mobile,
          is_email_verified: response.data.is_email_verified,
          is_mobile_verified: response.data.is_mobile_verified,
          is_user_verified: response.data.is_user_verified,
        });
      })
      .catch((err) => console.log(err));
  }

  async updateBannerImg() {
    const api = new Api();
    this.setState({ isSaving: true });
    const objBanner = {
      banner_picture: this.state.banner_picture,
      user_id: this.state.user_id,
    };

    await api
      .post("update_banner_image/", objBanner)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        notifications.success("Banner Image saved successfully");
        // const timer = setTimeout(() => {
        //   this.setState({ redirectToUserProfile: true });
        // }, 1000);
      })
      .catch((err) => console.log(err));
  }

  async updateProfileImg() {
    const api = new Api();
    this.setState({ isSaving: true });
    const objProfile = {
      profile_picture: this.state.profile_picture,
      user_id: this.state.user_id,
    };

    await api
      .post("update_profile_image/", objProfile)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        notifications.success("Profile Image saved successfully");
        console.log(response.data);
        // const timer = setTimeout(() => {
        //   this.setState({ redirectToUserProfile: true });
        // }, 1000);
      })
      .catch((err) => console.log(err));
  }

  UserData() {
    const api = new Api();
    this.setState({ isSaving: true });
    const objInfo = {
      bio: this.state.bio,
      custom_url: this.state.custom_url,
      personal_website: this.state.personal_website,
      user_id: this.state.user_id,
      user_name: this.state.user_name,
    };

    api
      .post("update_profile_information/", objInfo)
      .then((response) => {
        notifications.success("Profile updated successfully");
        //alert("Profile updated successfully")
        this.setState({ openPopup: true, isSaving: false });
      })
      .catch((err) => console.log(err));
  }

  async handleChange(e) {
    console.log(e.target.value, e.target.name);
    if (e.target.name == "mobile") {
      const re = /^[0-9\b]+$/;
      if (re.test(e.target.value) || e.target.value == "") {
        await this.setState({ [e.target.name]: e.target.value }, () => {});
      }
    } else if (e.target.name == "user_name") {
      const regexp = /^\S*$/; ///^[a-zA-Z_]*$/;
      if (regexp.test(e.target.value) || e.target.value == "") {
        await this.setState({ [e.target.name]: e.target.value }, () => {});
      }
    } else {
      await this.setState({ [e.target.name]: e.target.value }, () => {});
      this.formValChange(e);
    }

    console.log(this.state);
  }

  saveUserData() {
    this.formValChange({
      target: { name: "user_name", value: this.state.user_name },
    });
    if (this.formValid(this.state)) {
      this.UserData();
      return;
    }
  }
  saveOther(flag) {
    if (flag == 1) {
      if (this.emailValidation()) {
        this.userEmail();
      }
    } else if (flag == 2) {
      if (this.phoneValidation()) {
        this.userMobile();
      }
    } else if (flag == 3) {
      this.userTwitter();
    }
  }

  clickOnSubmit(flag) {
    if (
      flag == 1 &&
      this.state.otp1 &&
      this.state.otp2 &&
      this.state.otp3 &&
      this.state.otp4 &&
      this.state.otp5 &&
      this.state.otp6
    ) {
      this.setState(
        {
          otp:
            this.state.otp1 +
            "" +
            this.state.otp2 +
            "" +
            this.state.otp3 +
            "" +
            this.state.otp4 +
            "" +
            this.state.otp5 +
            "" +
            this.state.otp6,
        },
        console.log(this.state.otp)
      );
      this.otpValidationEmail();
    } else if (
      flag == 2 &&
      this.state.otp1 &&
      this.state.otp2 &&
      this.state.otp3 &&
      this.state.otp4 &&
      this.state.otp5 &&
      this.state.otp6
    ) {
      this.setState(
        {
          otp:
            this.state.otp1 +
            "" +
            this.state.otp2 +
            "" +
            this.state.otp3 +
            "" +
            this.state.otp4 +
            "" +
            this.state.otp5 +
            "" +
            this.state.otp6,
        },
        console.log(this.state.otp)
      );
      this.otpValidationMobile();
    }
  }
  otpValidationEmail() {
    const api = new Api();
    //this.setState({ isSaving: true });
    const objotp = {
      otp: this.state.otp,
      user_id: this.state.user_id,
    };

    api
      .post("verify_email/", objotp)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.isValidOTP) {
          this.setState({
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otp5: "",
            otp6: "",
            popupFor: null,
          });
          this.setState({ is_email_verified: true });
          notifications.success("Email Verified Successfully");
        } else {
          notifications.error("OTP Invalid");
        }
      })
      .catch((err) => console.log(err));
  }

  otpValidationMobile() {
    const api = new Api();
    this.setState({ isSaving: true });
    const objotp = {
      otp: this.state.otp,
      user_id: this.state.user_id,
    };

    api
      .post("verify_mobile/", objotp)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.isValidOTP) {
          this.setState({
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otp5: "",
            otp6: "",
            popupFor: null,
          });
          this.setState({ is_mobile_verified: true });
          notifications.success("Mobile Verified Successfully");
        } else {
          notifications.error("OTP Invalid");
        }
      })
      .catch((err) => console.log(err));
  }

  resendOTP(flag) {
    const api = new Api();
    let url = "";
    if (flag == 1) {
      url = "resend_email_otp/?user_id=" + this.state.user_id;
    } else if (flag == 2) {
      url = "resend_mobile_otp/?user_id=" + this.state.user_id;
    }
    api
      .get(url)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.message) {
          this.setState({
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otp5: "",
            otp6: "",
          });
          notifications.success("OTP sent Successfully");
        } else {
          notifications.error("OTP not Sent");
        }
      })
      .catch((err) => console.log(err));
  }

  function(val) {
    if (val < 6) {
      let ele = document.getElementsByClassName("otp");
      console.log(ele);
      if (ele[val - 1].value != "" && ele[val]) {
        ele[val].focus();
      } else if (ele[val - 1].value == "") {
        ele[val - 2].focus();
      }
    }
  }
  async onlyDigit(e) {
    const re = /^[0-9\b]+$/;
    if (re.test(e.target.value) || e.target.value == "") {
      await this.setState({ [e.target.name]: e.target.value });
      if (
        e.target.name == "otp1" ||
        e.target.name == "otp2" ||
        e.target.name == "otp3" ||
        e.target.name == "otp4" ||
        e.target.name == "otp5" ||
        e.target.name == "otp6"
      ) {
        if (e.target.name == "otp1") {
          this.function(1);
        } else if (e.target.name == "otp2") {
          this.function(2);
        } else if (e.target.name == "otp3") {
          this.function(3);
        } else if (e.target.name == "otp4") {
          this.function(4);
        } else if (e.target.name == "otp5") {
          this.function(5);
        } else if (e.target.name == "otp6") {
          this.function(6);
        }
      }
      if (
        e.target.name == "otp1" ||
        e.target.name == "otp2" ||
        e.target.name == "otp3" ||
        e.target.name == "otp4" ||
        e.target.name == "otp5" ||
        e.target.name == "otp6"
      ) {
        await this.setState(
          {
            otp:
              this.state.otp1 +
              "" +
              this.state.otp2 +
              "" +
              this.state.otp3 +
              "" +
              this.state.otp4 +
              "" +
              this.state.otp5 +
              "" +
              this.state.otp6,
          },
          () => {
            console.log(this.state.otp);
          }
        );
      }
    } else {
      return false;
    }
  }

  checkMobileEmailVal(flag) {
    let result = false;
    if (flag == 1) {
      let EMAIL_REGEXP =
        /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
      if (
        this.state.email == "" ||
        EMAIL_REGEXP.test(this.state.email) === false
      ) {
        result = true;
      }
    } else if (flag == 2) {
      if (this.state.mobile == "") {
        result = true;
      }
    } else if (flag == 3) {
      if (this.state.twitter_profile == "") {
        result = true;
      }
    }
    return result;
  }

  getVerified() {
    new Api().get("get_verified/?user_id=" + this.state.user_id).then(
      (response) => {
        notifications.success("Notification successfully sent to RedShilliz.");
      },
      (err) => {
        notifications.error("Something went wrong.");
      }
    );
  }

  userEmail() {
    const api = new Api();
    //this.setState({ isSaving: true });
    const objemail = {
      email: this.state.email,
      user_id: this.state.user_id,
    };

    api
      .post("update_email/", objemail)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.account) {
          this.setState({
            //popupFor: response.data.is_email_verified ? null : 1,
            popupFor: 1,
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otp5: "",
            otp6: "",
          });
        }
        // else{
        //   notifications.error("Email id not saved")
        // }
      })
      .catch((err) => {
        console.log(err);
        notifications.error("Something went wrong.");
      });
  }

  emailValidation() {
    let EMAIL_REGEXP =
      /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    console.log(this.state.email);
    if (!this.state.email || EMAIL_REGEXP.test(this.state.email) === false) {
      if (this.state.email == "" || this.state.email == null) {
        this.setState({
          error: "Email is required",
        });
      } else {
        this.setState({
          error: "Email is not valid",
        });
      }
      return false;
    } else {
      this.setState({ error: null });
      return true;
    }
  }

  phoneValidation() {
    const regex = /^([+]\d{2})?\d{12}$/; ///^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
    const indiaRegex =
      "^(\\+\\d{2}( )?)?((\\(\\d{3}\\))|\\d{3})[- .]?\\d{3}[- .]?\\d{4}$";
    console.log(this.state.mobile);
    if (this.state.mobile == 0 || this.state.mobile == "") {
      //|| regex.test(this.state.mobile) === false){
      this.setState({
        message: "Phone Number is required",
      });
      return false;
    } else {
      this.setState({ message: null });
      return true;
    }
  }

  userMobile() {
    const api = new Api();
    const objMob = {
      mobile: this.state.mobile,
      user_id: this.state.user_id,
    };
    api
      .post("update_mobile/", objMob)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.account) {
          this.setState(
            {
              //popupFor: response.data.is_mobile_verified ? null : 2,
              popupFor: 2,
              otp1: "",
              otp2: "",
              otp3: "",
              otp4: "",
              otp5: "",
              otp6: "",
            },
            console.log(response.data)
          );
        }
      })
      .catch((err) => {
        console.log(err);
        notifications.error("Something went wrong.");
      });
  }

  userTwitter() {
    const api = new Api();
    // this.setState({ isSaving: true });
    const obj = {
      twitter_profile: this.state.twitter_profile,
      user_id: this.state.user_id,
    };

    api
      .post("update_twitter_username/", obj)
      .then((response) => {
        this.setState({ openPopup: true, isSaving: false });
        if (response.data.account) {
          notifications.success("Twitter name saved successfully");
        }
      })
      .catch((err) => console.log(err));
  }

  async onChangeFun(e, forImage) {
    let t = this;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    console.log(files[0]);

    const reader = new FileReader();
    reader.onload = () => {
      let fileName = files[0]["name"];
      let text = fileName.split(".").pop().toLowerCase();
      console.log(text);
      if (
        text === "png" ||
        text === "jpg" ||
        text === "jpeg" ||
        text === "svg"
      ) {
        console.log(forImage);
        if (forImage == 1) {
          this.setState({ banner_picture: reader.result });
          this.updateBannerImg();
          this.state.inputtype = "text";
          this.state.inputtype = "file";
          //notifications.success("Banner Image saved successfully");
        } else if (forImage == 2) {
          this.setState({ profile_picture: reader.result });
          console.log(this.state.profile_picture);
          this.updateProfileImg();
          this.state.inputtype = "text";
          this.state.inputtype = "file";
          // notifications.success("Profile Image saved successfully");
        }
      } else {
        //setExtension(true);
      }
      this.setState({ Preview: true });
    };
    reader.readAsDataURL(files[0]);
  }

  formValid({ isError, ...rest }) {
    let isValid = false;
    if (this.dName == "") {
      //|| this.profileImgName=='' || this.bannerImageName==''){
      isValid = true;
    }
    if (this.state.user_name == "") {
      //|| this.state.profile_picture=='' || this.state.banner_picture==''){
      isValid = false;
    }
    return isValid;
  }

  formValChange(e) {
    // e.preventDefault();
    const { name, value } = e.target;
    console.log(name, value);
    let isError = { ...this.state.isError };
    switch (name) {
      case "user_name":
        this.dName = value.length == 0 ? "Name is required" : "";
        // this.state.isError.dName = value.length == 0 ? "Name is required" : "";
        break;
      case "collection":
        this.profileImgName = value == 0 ? "image is required" : "";
        // this.state.isError.cImageName =value == 0 ? "image is required" : "";
        break;
      case "banner":
        this.bannerImageName = value == 0 ? "Banner image is required" : "";
        // this.state.isError.bannerImageName =value == 0 ? "Banner image is required" : "";
        break;
      default:
        break;
    }
    this.setState({
      isError,
      [name]: value,
    });
    console.log(this.state.isError);
  }

  render() {
    return (
      <>
        <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
        <Header />

        <div
          className="verify-popup"
          style={{
            display:
              this.state.popupFor == 1 || this.state.popupFor == 2
                ? "inline-flex"
                : "none",
          }}
        >
          <div className="verify-popup__aside">
            <a
              href="javascript:void(0)"
              onClick={(e) => this.setState({ popupFor: null })}
              className="btn-close"
            >
              <img src="../images/svg/close.svg" alt="" />{" "}
            </a>
            <div className="section-title">
              <h2>
                Verify your {this.state.popupFor == 1 ? "EMAIL" : "MOBILE"}
              </h2>
              <p>
                You will receive a SMS containing the verification code on your{" "}
                {this.state.popupFor == 1 ? "email" : "mobile"}{" "}
                <a href="javascript:void(0)">
                  {this.state.popupFor == 1
                    ? this.state.email
                    : this.state.mobile}
                </a>
              </p>
            </div>
            <div className="verify-popup__form">
              <form className="mt-5">
                <div className="verify-popup__form-field">
                  <input
                    className="otp"
                    type="text"
                    onKeyUp="tabChange(1)"
                    maxLength="1"
                    spellCheck="false"
                    data-ms-editor="true"
                    name="otp1"
                    value={this.state.otp1}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <input
                    className="otp"
                    type="text"
                    maxLength="1"
                    spellCheck="false"
                    onKeyUp="tabChange(2)"
                    data-ms-editor="true"
                    name="otp2"
                    value={this.state.otp2}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <input
                    className="otp"
                    type="text"
                    maxLength="1"
                    spellCheck="false"
                    data-ms-editor="true"
                    name="otp3"
                    value={this.state.otp3}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <input
                    className="otp"
                    name="otp4"
                    type="text"
                    maxLength="1"
                    spellCheck="false"
                    data-ms-editor="true"
                    value={this.state.otp4}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <input
                    className="otp"
                    name="otp5"
                    type="text"
                    maxLength="1"
                    spellCheck="false"
                    data-ms-editor="true"
                    value={this.state.otp5}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <input
                    className="otp"
                    name="otp6"
                    type="text"
                    maxLength="1"
                    spellCheck="false"
                    data-ms-editor="true"
                    value={this.state.otp6}
                    onChange={(e) => {
                      this.onlyDigit({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                <div className="verify-popup__form-btn">
                  <a
                    href="javascript:void(0)"
                    onClick={(e) => {
                      this.clickOnSubmit(this.state.popupFor);
                    }}
                    className="button"
                  >
                    Verify
                  </a>
                </div>
                <div className="verify-popup__form-text">
                  <p>
                    Didn’t receive the OTP?{" "}
                    <a
                      onClick={(e) => {
                        this.resendOTP(this.state.popupFor);
                      }}
                    >
                      Resend
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="container">
          <section className="user-profile edit-profile-result">
            <section className="user-board">
              <div className="user-board__img">
                <img
                  alt="" 
                  src={
                    this.state.banner_picture
                      ? this.state.banner_picture
                      : "../images/default_banner.png"
                  }
                />
                <div className="user-board__img-aside">
                  <div className="container">
                    <button className="button btn-edit-profile">
                      <label
                        htmlFor="contained-button-file"
                        style={{
                          // display:
                          //   this.state.banner_picture != "" ? "flex" : "none",
                          pointerEvents: "auto",
                        }}
                      >
                        <input
                          type={this.state.inputtype}
                          accept="image/*"
                          style={{ display: "none" }}
                          id="contained-button-file"
                          name="banner_picture"
                          onChange={(e) => this.onChangeFun(e, 1)}
                        />
                        <img src="../images/svg/edit.svg" alt="" />
                        <span style={{ color: "#ffffff" }}>Edit Banner</span>
                      </label>
                    </button>
                  </div>
                </div>
              </div>
              <div className="user-board__data">
                <div className="container">
                  <div className="user-board__data-img">
                    <img
                      className="user-board__img" //src="../images/nft-details.jpg"  alt="" style={{ display: this.state.profile_picture == "" ? "none" : "block" }}
                      src={
                        this.state.profile_picture
                          ? this.state.profile_picture
                          : "../images/default_image.png"
                      }
                    />
                    <button className="button btn-edit-profile">
                      <label
                        htmlFor="contained-button-file1"
                        // style={{
                        //   display:
                        //     this.state.profile_picture != "" ? "block" : "none",
                        // }}
                      >
                        <input
                          type={this.state.inputtype} //"file"
                          accept="image/*"
                          style={{ display: "none" }}
                          id="contained-button-file1"
                          name="profile_picture"
                          onChange={(e) => this.onChangeFun(e, 2)}
                        />
                        <img src="../images/svg/edit.svg" alt="" />
                      </label>
                    </button>
                  </div>
                  <div className="user-board__data-ttl just">
                    <h1>EDIT PROFILE</h1>
                  </div>
                </div>
              </div>
            </section>
            <div className="exploreNfts">
              <div className="container">
                <div className="edit-profile__form edit-profile-result__form">
                  <div className="form-group">
                    <label> Display Name</label>
                    <div className="form-control__wrapp">
                      <input
                        type="text"
                        className="form-control"
                        pattern="/^\S*$/"
                        placeholder="Enter your display name"
                        readOnly={this.state.isSaving}
                        value={this.state.user_name}
                        name="user_name"
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    <p className="error">{this.dName}</p>
                  </div>
                  <div className="form-group">
                    <label> URL </label>
                    <div className="form-control__wrapp url">
                      <span>redshilliz.com/</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your custom URL"
                        name="custom_url"
                        readOnly={this.state.isSaving}
                        value={this.state.custom_url}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label> Bio </label>
                    <div className="form-control__wrapp">
                      <textarea
                        className="form-control textarea" //name="collection_description"
                        placeholder="Enter a detailed description about yourself"
                        value={this.state.bio}
                        readOnly={this.state.isSaving}
                        name="bio"
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group">
                    <label> Personal Website URL </label>
                    <div className="form-control__wrapp">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="https://www.yoursite.io/"
                        value={this.state.personal_website}
                        readOnly={this.state.isSaving}
                        name="personal_website"
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    {/* {this.state.isSaving ? (
                      <div className="form-group__btn">
                        <div className="button btn-waiting ">
                          <img
                            className="loader"
                            src="../Loader/redshilliz-loader.gif "
                            alt="Coin"
                          />
                          Updating...
                        </div>
                      </div>
                    ) : ( */}
                    <button
                      className="button"
                      onClick={() => this.saveUserData()}
                    >
                      Save Changes
                    </button>
                    {/* )} */}
                  </div>
                </div>

                <div className="edit-profile__form edit-profile-result__form">
                  <div className="form-group">
                    <label>
                      {" "}
                      Email
                      <span
                        className="verified-text"
                        style={{
                          display:
                            this.state.is_email_verified == false
                              ? "none"
                              : "block",
                        }}
                      >
                        Verified
                      </span>
                    </label>
                    <div className="form-control__wrapp">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your email"
                        name="email"
                        value={this.state.email}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />

                      <button
                        className={
                          this.checkMobileEmailVal(1)
                            ? "btn-save"
                            : "button btn-save"
                        }
                        disabled={this.checkMobileEmailVal(1) ? true : null}
                        onClick={() => this.saveOther(1)}
                      >
                        Save
                      </button>
                      {/* <button className="button"  onClick={''}>Save</button> */}
                    </div>
                    <span className="text-danger" style={{ color: "red" }}>
                      {this.state.error}
                    </span>
                  </div>
                  <div className="form-group">
                    <label>
                      {" "}
                      Mobile Number{" "}
                      <span
                        className="verified-text"
                        style={{
                          display:
                            this.state.is_mobile_verified == false
                              ? "none"
                              : "block",
                        }}
                      >
                        Verified
                      </span>
                    </label>
                    <div className="form-control__wrapp">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your mobile number"
                        name="mobile"
                        value={this.state.mobile}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                      <button
                        className={
                          this.checkMobileEmailVal(2)
                            ? "btn-save"
                            : "button btn-save"
                        }
                        disabled={this.checkMobileEmailVal(2) ? true : null}
                        onClick={() => this.saveOther(2)}
                      >
                        Save
                      </button>
                    </div>
                    <span className="text-danger" style={{ color: "red" }}>
                      {this.state.message}
                    </span>
                  </div>
                  <div className="form-group">
                    <label> Twitter Username </label>
                    <div className="form-control__wrapp">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="@ Enter your Twitter username"
                        name="twitter_profile"
                        value={this.state.twitter_profile}
                        onChange={(e) => {
                          this.handleChange({
                            target: {
                              name: e.target.name,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                      <button
                        className={
                          this.checkMobileEmailVal(3)
                            ? "btn-save"
                            : "button btn-save"
                        }
                        disabled={this.checkMobileEmailVal(3) ? true : null}
                        onClick={() => this.saveOther(3)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="form-group text-note">
                    <label>
                      {" "}
                      Identity Verification{" "}
                      <span
                        className="verified-text"
                        style={{
                          display:
                            this.state.is_user_verified == false
                              ? "none"
                              : "block",
                        }}
                      >
                        Verified
                      </span>{" "}
                    </label>
                    <p>
                      Proceed with verification process to get more visibility
                      and increase credibility on RedShilliz. This process may
                      take upto xyz number of days.
                    </p>
                    {!this.state.is_user_verified ? (
                      <button
                        onClick={() => this.getVerified()}
                        className="button purple-outline"
                      >
                        Get Verified
                      </button>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </>
    );
  }
}
